import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { api } from "@/lib/api";

import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/site/Home";
import Services from "@/pages/site/Services";
import ServiceDetail from "@/pages/site/ServiceDetail";
import Realisations from "@/pages/site/Realisations";
import RealisationDetail from "@/pages/site/RealisationDetail";
import Conseils from "@/pages/site/Conseils";
import ArticleDetail from "@/pages/site/ArticleDetail";
import Faq from "@/pages/site/Faq";
import Contact from "@/pages/site/Contact";
import { MentionsLegales, Confidentialite } from "@/pages/site/Legal";

import Login from "@/pages/admin/Login";
import ResetPassword from "@/pages/admin/ResetPassword";
import ProtectedRoute from "@/pages/admin/ProtectedRoute";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import RealisationsAdmin from "@/pages/admin/RealisationsAdmin";
import SeoTools from "@/pages/admin/SeoTools";
import ArticlesAdmin from "@/pages/admin/ArticlesAdmin";
import KeywordsAdmin from "@/pages/admin/KeywordsAdmin";
import Analytics from "@/pages/admin/Analytics";
import LeadsAdmin from "@/pages/admin/LeadsAdmin";
import AgentsAdmin from "@/pages/admin/AgentsAdmin";
import PartnersAdmin from "@/pages/admin/PartnersAdmin";
import LiveChat from "@/pages/admin/LiveChat";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";
import AccountAdmin from "@/pages/admin/AccountAdmin";

let sid = localStorage.getItem("smt_sid");
if (!sid) { sid = Math.random().toString(36).slice(2); localStorage.setItem("smt_sid", sid); }

function Tracker() {
  const loc = useLocation();
  useEffect(() => {
    if (loc.pathname.startsWith("/admin")) return;
    api.post("/track", { path: loc.pathname, referrer: document.referrer, session_id: sid }).catch(() => {});
    window.scrollTo(0, 0);
  }, [loc.pathname]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Tracker />
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/realisations" element={<Realisations />} />
            <Route path="/realisations/:slug" element={<RealisationDetail />} />
            <Route path="/conseils" element={<Conseils />} />
            <Route path="/conseils/:slug" element={<ArticleDetail />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
          </Route>

          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/reset-password" element={<ResetPassword />} />
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="realisations" element={<RealisationsAdmin />} />
            <Route path="seo" element={<SeoTools />} />
            <Route path="articles" element={<ArticlesAdmin />} />
            <Route path="keywords" element={<KeywordsAdmin />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="leads" element={<LeadsAdmin />} />
            <Route path="chat" element={<LiveChat />} />
            <Route path="team" element={<AgentsAdmin />} />
            <Route path="partners" element={<PartnersAdmin />} />
            <Route path="settings" element={<SettingsAdmin />} />
            <Route path="account" element={<AccountAdmin />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
